// removed by extract-text-webpack-plugin
module.exports = {"head":"src-display-platform-AppStore-UI-Head-index__head--3Dr52","pageHeaderTitle":"src-display-platform-AppStore-UI-Head-index__pageHeaderTitle--16on8","breadcrumbContainer":"src-display-platform-AppStore-UI-Head-index__breadcrumbContainer--2y1OR","breadcrumb":"src-display-platform-AppStore-UI-Head-index__breadcrumb--1FZJG","buttList":"src-display-platform-AppStore-UI-Head-index__buttList--1Es0M","tabs":"src-display-platform-AppStore-UI-Head-index__tabs--33inm","on":"src-display-platform-AppStore-UI-Head-index__on--2i8NV"};


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/AppStore/UI.Head/index.scss
// module id = 6644
// module chunks = 0